<template>
  <div class="passwordSet">
    <head-panel title="账号管理" subtitle="ACCOUNT MANAGEMENT" :exportExc="false"></head-panel>
    <div class="formPanel">
      <h3 class="subTit">{{currentTitle}}</h3>
      <el-form :model="form" ref="form" class="ruleForm" :rules="rules" label-width="12%">
        <el-form-item label="账户名称" prop="name">
          <el-input class="input_sm" placeholder="请输入账户名称" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-button type="primary" size="small" @click="changePass">修改密码</el-button>
        </el-form-item>
        <el-form-item prop="passNow" label="请输入当前密码" v-if="passwordShow">
          <el-input v-model="form.passNow" type="password" class="input_sm"></el-input>
        </el-form-item>
        <el-form-item prop="pass" label="输入新密码" v-if="passwordShow">
          <el-input v-model="form.pass" type="password" class="input_sm"></el-input>
        </el-form-item>
        <el-form-item prop="checkPass" label="再次确认新密码" v-if="passwordShow">
          <el-input v-model="form.checkPass" type="password" class="input_sm"></el-input>
        </el-form-item>
        <el-form-item class="btnGroups" v-if="passwordShow">
          <el-button size="large" type="primary" @click="submitForm('form')">提交</el-button>
          <el-button size="large" class="is-cancel" @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { headPanel } from '@/global/components';
import { post } from '@/agent/http';
export default {
  data () {
    var validatePass = (rule, value, callback) => {
      let re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,20}$/
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length > 20 || value.length < 6) {
        callback(new Error('密码长度不少于6个字符,不超过20个字符'));
      } else if (!re.test(value)) {
        callback(new Error('密码至少包含大写字母，小写字母，数字'));
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      currentTitle: '密码设置',
      passwordShow: false,
      form: {
        pass: '',
        checkPass: '',
        name: '',
        passNow: ''
      },
      rules: {
        name: [{ required: true, message: '请输入账户名称', trigger: 'blur' }],
        passNow: [{ required: true, message: '请输入当前密码', trigger: 'blur' }],
        pass: [{ required: true, validator: validatePass, trigger: 'blur' }],
        checkPass: [{ required: true, validator: validatePass2, trigger: 'blur' }]
      }
    };
  },
  computed: {
    ...mapGetters({
      accountinfo: 'account/account',
      userid: 'login/userid',
      user: 'login/user'
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.form.name = this.user.username
    },
    submitForm (numberValidateForm) {
      let self = this
      this.$refs[numberValidateForm].validate((valid) => {
        if (valid) {
          post('/agency/account/updatePwd/' + self.userid, {
            username: self.form.name,
            old_pwd: self.form.passNow,
            new_pwd: self.form.pass,
            new_pwd_confirmation: self.form.checkPass
          }).then(res => {
            if (res.code === 1) {
              self.$message('密码更新成功')
              self.passwordShow = false
              self.form.pass = '';
              self.form.checkPass = '';
              self.form.passNow = ''
            } else {
              self.$message.error(res.msg)
            }
          })
        }
      });
    },
    changePass () {
      this.passwordShow = !this.passwordShow;
    },
    cancel () {
      this.form.pass = '';
      this.form.checkPass = '';
      this.passwordShow = false
    }
  },
  components: {
    headPanel
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss">
.passwordSet {
  .ruleForm {
    .input_sm {
      width: 210px;
    }
    .el-form-item {
      margin-bottom: 22px;
    }
    .btnGroups {
      text-align: left;
      margin-left: 16px;
    }
  }
}
</style>
